import { Heart, Printer, Share2, X, Youtube } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "~/components/ui/dialog";
import { cn } from "~/lib/utils";
import { ShareDialogContent } from "./ShareModalContent";
import VirtualTour from "./VirtualTour";
import { Listing } from "./Interfaces/ListingsInterface";
import { Property } from "./Interfaces/PropertiesInterface";

export const ActionButtons = ({
  className,
  liked,
  data,
  toggleFavorite,
  videoUrl,
  url,
  hidePrint = true,
  heading = "Share this Property",
  isListingsPage
}: {
  className?: string;
  liked?: boolean;
  toggleFavorite?: () => void;
  data?: Listing | Property;
  region?: string;
  videoUrl?: string;
  url: string;
  hidePrint?: boolean;
  heading?: string;
}) => {

  const handlePrint = () => {
    window.print();
  };

  const [firstListingImage] = data?.assets || [];

  const media = firstListingImage;

  return (
    <div className={cn(" flex justify-end gap-3", className)}>
      {!hidePrint &&
        <button
          onClick={handlePrint}
          className='p-2.5 border border-gray-250 rounded-md hover:bg-gray-500 group'
          aria-label="Print this page"
          type="button"
        >
          <Printer size={20} className='text-gray-800 group-hover:text-white' aria-hidden="true" />
        </button>
      }
      {videoUrl && (
        <Dialog>
          <DialogTrigger asChild>
            <button
              className='p-2.5 border border-gray-250 rounded-md hover:bg-gray-500 group'
              aria-label="Open virtual tour"
              type="button"
            >
              <Youtube
                size={20}
                className='text-gray-800 group-hover:text-white'
                aria-hidden="true"
              />
            </button>
          </DialogTrigger>
          <DialogContent className='sm:max-w-3xl'>
            <VirtualTour url={videoUrl} />
          </DialogContent>
        </Dialog>
      )}
      <Dialog>
        <DialogTrigger asChild>
          <button
            className='p-2.5 border border-gray-250 rounded-md hover:bg-gray-500 group'
            aria-label="Share this property"
            type="button"
          >
            <Share2
              size={22}
              className='text-gray-800 group-hover:text-white'
              aria-hidden="true"
            />
          </button>
        </DialogTrigger>
        <DialogContent className="px-4 py-0 gap-2">
          <ShareDialogContent
            url={url}
            title={heading}
            media={media?.url}
          />
        </DialogContent>
      </Dialog>
      {isListingsPage && (
        <button
          className='p-2.5 border border-gray-250 rounded-md hover:bg-gray-500 group'
          onClick={toggleFavorite}
          aria-label={liked ? "Remove from favorites" : "Add to favorites"}
          type="button"
        >
          <Heart
            size={20}
            className={cn(
              "text-gray-800 group-hover:text-white",
              liked && "fill-red-500 text-red-500",
            )}
            aria-hidden="true"
          />
        </button>
      )}
    </div>
  );
};
